/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { Component, Router } from 'llama'
import FaceConfig from '../../common/FaceConfig'
import FaceDrawer from '../../common/FaceDrawer'
import OnboardingRoutes from '../OnboardingRoutes'

export default class FacePortrait extends Component {
  constructor (opt) {
    super({
      ...opt
    })

    this.faceDrawer = new FaceDrawer()
  }

  init (params) {
    this.zoom = params.zoom
    this.printPortrait()

    this.on(Router.LAND, (params) => {
      this.zoom = params.zoom
      if ('zoom' in params) this.printPortrait()
    })

    this.on(FaceConfig.UPDATE, () => { this.printPortrait() })
  }

  printPortrait () {
    const config = FaceConfig.get()
    const zoom = this.zoom || 'portrait'
    const fullFace = this.prepareBox()
    const ctx = fullFace.getContext('2d')
    this.faceDrawer.cleanAll(ctx)
    if (zoom === OnboardingRoutes.Full) {
      const ratio = 0.7
      this.faceDrawer.drawFullSizeBody(ctx, config, ratio, { top: -5, left: 140 })
    }
    if (zoom === OnboardingRoutes.Portrait) {
      const ratio = 2
      this.faceDrawer.drawMedalPortrait(ctx, config, ratio, { top: 20, left: 70, shiftTop: 50, shiftLeft: 50, radius: 1.4 })
    }
  }
}
